import { render, staticRenderFns } from "./SettingCasualInterviewRequestAutoReply.vue?vue&type=template&id=12a6496c"
import script from "./SettingCasualInterviewRequestAutoReply.vue?vue&type=script&lang=js"
export * from "./SettingCasualInterviewRequestAutoReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports